<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>司机列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 校长视图 -->
    <el-card class="box-card" style="margin-top:20px">
      <el-form
        size="mini"
        :inline="true"
        :model="searchForm"
        :rules="searchRules"
        ref="searchForRef"
        label-width="100px"
        autocomplete="on"
      >
        <!---->
        <el-row :gutter="24">
          <el-col :span="21">
            <el-form-item label="搜索名称">
              <el-input @input="goSearch" v-model="searchForm.company_name" placeholder="请输入执照名称"  clearable type="text"></el-input>
            </el-form-item>
            <el-form-item label="类型">

            </el-form-item>
            <el-form-item label="状态" >
              <el-select width="500" @change="statusChange" clearable  v-model="searchForm.status"  placeholder="请选择状态">
                <el-option key="" label="全部" value="">
                </el-option>
                <el-option key="1" label="正常" value="1">
                </el-option>
                <el-option key="0" label="待审核" value="0">
                </el-option>
                <el-option key="2" label="驳回" value="2">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3" style="font-size: 14px">
            <div class="toggle-button" @click="isCollapsed =!isCollapsed">
              <span>筛选条件</span>
              <i :class="collapseIcon" class="el-icon--right"></i>
            </div>
          </el-col>
        </el-row>
        <!---->
        <el-collapse-transition>
          <div v-show="!isCollapsed" class="condition-content">
                <el-form-item label="创建时间">
                  <el-date-picker
                    @change="changeTime"
                    v-model="searchForm.start_end_date"
                    type="daterange"
                    align="right"
                    size="mini"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="startEndOptions">
                  </el-date-picker>
                </el-form-item>




          </div>
        </el-collapse-transition>
        <!---->
      </el-form>
      <div style="padding: 12px 0;display: flex;flex-direction: row;justify-content: space-between;align-items: center;">
        <div>
          <el-button @click="goAdd" type="primary"  size="mini">添加</el-button>
          <el-button @click="goExcel"  size="mini">导出</el-button>
        </div>

      </div>
      <el-table
        :data="tableLoadData"
        stripe
        size="mini"
        border
        ref="multipleTable"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column :index="indexMethod" fixed="left"  type="index" label="序号" width="50"></el-table-column>

        <el-table-column fixed="left"  label="姓名" width="100" >
          <template slot-scope="{row}">
            <span >{{row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="left"  label="电话" width="100" >
          <template slot-scope="{row}">
            <span >{{row.tel}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="left"  label="注册日期" width="160" >
          <template slot-scope="{row}">
            <span >{{row.register_time|timeFormat}}</span>
          </template>
        </el-table-column>

        <el-table-column label="状态"  :show-overflow-tooltip='true'  >
          <template slot-scope="{row}">
            <div style="color: #5daf34">{{row.status==1?'正常':''}}</div>
            <div style="color: #ff0000">{{row.status==0?'待审':''}}</div>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="120">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status==0" style="color:#F00;" type="text" size="mini" @click="goEdit(scope.row,scope.$index)">审核</el-button>
            <el-button v-if="scope.row.status==1" type="text" size="mini"  style="color: #5daf34">已审核</el-button>
            <el-button  style="color: #ff0000" type="text" size="mini" @click="goDel(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        style="margin-top: 20px; text-align: right"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>

    <el-drawer
      title="审核处理"
      :visible.sync="drawer1"
      size="40%"
      :with-header="false">
      <div style="padding: 12px;">
        <el-form
          size="mini"
          :inline="true"
          :model="addForm"
          ref="addFormRef"
          label-width="80px"
          autocomplete="on"
          :rules="rules"
          style="width: 100%"
        >
           <div>
          <el-form-item required label="内容" style="padding-bottom: 12px">

            <el-input v-model="addForm.title"  disabled
                      type="textarea"
                      :rows="4"></el-input>
          </el-form-item>
           </div>
          <div>
          <el-form-item label="处理日期" style="padding-bottom: 12px">
            <el-date-picker
              v-model="addForm.deal_time"
              type="date"
              placeholder="选选择出生日期"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            />
          </el-form-item>
          </div>
          <div>
          <el-form-item label="状态" style="padding-bottom: 12px">
            <el-select width="400" v-model="addForm.status"  placeholder="请选择状态">
              <el-option key="1" label="正常" value="1">
              </el-option>
              <el-option key="0" label="待处理" value="0">
              </el-option>
              <el-option key="2" label="驳回" value="2">
              </el-option>
            </el-select>
          </el-form-item>
          </div>
        </el-form>
        <!---->
        <footer>
          <div style="display: flex;flex-direction: row;justify-content: flex-end">
            <el-button  size="mini" @click="drawer1=false">取消</el-button>
            <el-button type="primary" @click="onSubmit('addFormRef')" icon="el-icon-plus" size="mini">保存</el-button>
          </div>
        </footer>
      </div>
    </el-drawer>

    <el-dialog title="订单退款" :visible.sync="dialogRefund">
      <el-form :model="addForm">
        <el-form-item required label="退款原因" :label-width="formLabelWidth">
          <el-input v-model="addForm.refund_reason" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item required label="退款金额" :label-width="formLabelWidth">
          <el-input v-model="addForm.refund_amount" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="操作类型">
          <el-radio-group  v-model="addForm.refund_type">
            <el-radio @click.native.prevent="handleRefundClick(item.id)" v-for="(item) in refundTypeList" :key="item.id"  :label=item.id>{{item.name}}</el-radio>

          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogRefund = false">取 消</el-button>
        <el-button type="primary" @click="goRefundSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import moment from "moment";
  export default {
    name: "orderOilList",
    components: {
    },
    data() {
      return {
        d_index:'',
        dialogRefund:false,
        formLabelWidth:200,
        startEndOptions:{
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        isStudent:false,
        refundTypeList:[{id:1,name:'线下'},{id:2,name:'系统自动'}],
        addForm:{
          title:'',
          refund_amount:0,
          refund_type:'',
          formLabelWidth:200,
          refund_reason:'',
          add_time:'',
          company_name:'',
          type:'',
          deal_time:'',
          status:'',
          id:'',
          name:'',
          sex:'',
          mobile:'',
          relaction_id:'',
          birthday:''
        },
        relationList:[],
        rules: {
          name:[
            { required: true, message: "请输入学员姓名", trigger: 'change' }
          ],
          mobile:[
            { required: true, message: "请输入手机号", trigger: 'change' }
          ],
        },
        drawer1:false,

        isCollapsed:true,

        checkAll: false,
        isIndeterminate: false,
        multipleSelection: [],

        formData:{},
        visible:false,
        title: '',

        searchForm:{
          start_end_date:'',
          start_end_date1:'',
          type_id:'',
          start_time:'',
          end_time:'',
          status:'',
          sex:"",
          keyword:'',
          proxy_id:sessionStorage.getItem('proxy_id'),
          shop_id:sessionStorage.getItem('shop_id'),
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        },
        searchRules:{

        },
        currentPage:1,
        pageSize:10,
        tableLoadData:[],
        total:0,

        userRole: 'principal', // 从实际登录信息获取，示例值：'principal' 或 'teacher'
        // 校长视图数据
        allClasses: [
          { id: 1, name: '高三（1）班' },
          { id: 2, name: '高三（2）班' }
        ],
        selectedClass: null,
        // 教师视图数据
        currentClass: {
          id: 1,
          name: '高三（1）班'
        },

        // 公共数据
        students: [],
        searchKey: '',
        scoreDialogVisible: false,
        currentStudent: {
          scores: {
            chinese: 0,
            math: 0,
            english: 0
          }
        }
      }
    },

    computed: {
      filteredStudents() {
        return this.students.filter(s =>
          s.name.includes(this.searchKey) ||
          s.studentId.includes(this.searchKey)
        )
      },
      collapseIcon() {
        return this.isCollapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'
      }
    },

    created() {
      // this.loadStudents()
      this.DataList();
      this.getDicList('eduRelation');
    },
    filters: {
      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD ");
      },
      timeFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },

    },
    methods: {
      indexMethod(index) {
        return (this.currentPage - 1) * this.pageSize + index + 1
      },
      goAdd(){

      },
      goExcel(){

      },
      goDetail(item){
        const param = {
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
          tax_id: item.id,
        }
          this.$axios.taxLeshuaQuery(param).then(res => {
            if (res.code != 200) {
              this.$message.error(res.msg);
            }
          })
      },
      handleRefundClick(val){
         if(this.addForm.refund_type===val){
           this.addForm.refund_type=null;
         }else{
           this.addForm.refund_type=val;
         }
      },
      goRefundSave(){

         let _this=this;
          const param = {
            company_id: sessionStorage.getItem('company_id'),
            access_token: sessionStorage.getItem('token'),
            tax_id: _this.addForm.id,
            refund_reason:_this.addForm.refund_reason,
            refund_amount:_this.addForm.refund_amount
          }
          if(this.addForm.refund_type==2){
            this.$axios.taxLeshuaRefund(param).then(res => {
              if (res.code == 200) {
                this.$message.success(res.msg);
                this.pageNum = 1;
                this.total = 0;
                this.tableLoadData = [];
                this.DataList()
              } else {
                this.$message.error(res.msg);
              }
            })
          }else  if(this.addForm.refund_type==1){
            this.$axios.taxRefund(param).then(res => {
              if (res.code == 200) {
                this.$message.success(res.msg);
                this.pageNum = 1;
                this.total = 0;
                this.tableLoadData = [];
                this.DataList()
              } else {
                this.$message.error(res.msg);
              }
            })
          }



      },
      goRefund(e) {
        let _this=this;
        this.$confirm('此操作将把订单退款, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
           _this.addForm.id=e.id;
           _this.addForm.refund_amount=e.order_amount;
           _this.dialogRefund=true;

        }).catch(action => {

          if (action === 'cancel') {
            this.$message({
              type: 'info',
              message: '取消操作'
            });
          }
        });

      },
      goDel(item) {
        this.$confirm('此操作将删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

           console.log(item)
            // const param = {
            //   id:item.id,
            //   company_id:sessionStorage.getItem('company_id'),
            //   access_token:sessionStorage.getItem('token'),
            // }
            // this.$axios.demandDel(param).then(res=>{
            //   if(res.code == 200){
            //     this.$message.success(res.msg);
            //     this.total=0;
            //     this.tableLoadData=[];
            //     this.currentPage=1;
            //     this.DataList()
            //   }else{
            //     this.$message.error(res.msg);
            //   }
            // }).catch(error=>{
            //   console.log(error);
            // })


        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });

        });
        this.teamDialog = false
      },
      statusChange(){
        this.goSearch();
      },
      changeTime(){
        this.goSearch();
      },
      changeTime1(){
        this.goSearch();
      },
      timeFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },
      goEdit(row,index){
        this.d_index=index;
        this.addForm.title=row.title;
        this.addForm.status=row.status+'';
        this.addForm.id=row.id;
        this.drawer1=true;
      },
      goSearch(){
        this.currentPage=1;
        this.tableLoadData=[];
        this.total=0;
        this.DataList();
      },
      getDicList(code){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          code:code,
        }
        this.$axios.dicListByPid(param).then(res=>{
          if(res.code == 200){
            if(code=='eduRelation'){
              this.relationList =res.data;
            }
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      onSubmit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submit();
          } else {
            return false;
          }
        });
      },
      submit() {
        let _this=this;
        let params={
          id:_this.addForm.id,
          deal_time:_this.addForm.deal_time,
          status:_this.addForm.status,
        };
        params.company_id=sessionStorage.getItem('company_id');
        params.access_token=sessionStorage.getItem('token');

        this.$axios.demandDeal(params).then(res=>{
          if(res.code == 200){
            this.$message.success("保存成功");

            this.tableLoadData[this.d_index].status=_this.addForm.status;
            this.drawer1=false;
          }
        }).catch(error=>{
          this.$message.error("保存错误");
          console.log(error);
        })
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        this.checkAll = this.multipleSelection.length === this.studentList.length;
        this.isIndeterminate = this.multipleSelection.length > 0 && !this.checkAll;
      },

      closeForm() {
        this.title = "";
        this.visible = false;
        this.pageNum=1;
        this.DataList()
      },
      DataList(){
        let _this=this;
        const param = {
          company_id:_this.searchForm.company_id,
          access_token:_this.searchForm.access_token,
          proxy_id:_this.searchForm.proxy_id,
          pageNum: this.currentPage,
          pageSize: this.pageSize,
        }

        if(this.searchForm.start_end_date){
          const [start_date,end_date]=this.searchForm.start_end_date;
          param.start_time=start_date.getFullYear()+'-'+(start_date.getMonth()+1)+"-"+start_date.getDate();
          param.end_time=end_date.getFullYear()+'-'+(start_date.getMonth()+1)+"-"+end_date.getDate();
        }
        if(this.searchForm.start_end_date1){
          const [start_date,end_date]=this.searchForm.start_end_date1;
          param.pay_start_time=start_date.getFullYear()+'-'+(start_date.getMonth()+1)+"-"+start_date.getDate();
          param.pay_end_time=end_date.getFullYear()+'-'+(start_date.getMonth()+1)+"-"+end_date.getDate();
        }
        if(!isNaN(this.searchForm.status)){
          param.status=this.searchForm.status;
        }
        if(!isNaN(this.searchForm.pay_status)){
          param.pay_status=this.searchForm.pay_status;
        }
        if(!isNaN(this.searchForm.type)){
          param.type=this.searchForm.type;
        }
        if(this.searchForm.company_name){
          param.company_name=this.searchForm.company_name;
        }
        param.order='register_time desc';

        this.$axios.ownerLgsListP(param).then(res=>{
          if(res.code == 200){
            this.tableLoadData = res.data.data;
            this.total = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize
        this.currentPage = 1;
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.currentPage = newPage
        this.DataList()
      },
      goInfo(row){
        this.$router.push({
          path:'/courseInfo',
          query:{
            id:row.id
          }
        })
      },

      async loadStudents() {
        // 根据角色调用不同API
        const apiUrl = this.userRole === 'principal'
          ? `/api/students?classId=${this.selectedClass}`
          : '/api/my-class/students'

        try {
          const res = await this.$axios.get(apiUrl)
          this.students = res.data
        } catch (error) {
          this.$message.error('数据加载失败')
        }
      },

      handleSearch() {
        // 防抖处理可根据需要添加
      },

      showScoreDialog(student) {
        this.currentStudent = JSON.parse(JSON.stringify(student))
        this.scoreDialogVisible = true
      },

      async saveScores() {
        try {
          await this.$axios.put(`/api/students/${this.currentStudent.id}/scores`,
            this.currentStudent.scores
          )
          this.$message.success('成绩保存成功')
          this.scoreDialogVisible = false
          this.loadStudents()
        } catch (error) {
          this.$message.error('保存失败')
        }
      }
    }
  }
</script>

<style scoped>

  .filter-bar {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .class-info {
    padding: 15px;
    background: #f5f7fa;
    border-radius: 4px;
    margin-bottom: 20px;
  }

  .class-info h3 {
    margin: 0 0 10px 0;
    color: #303133;
  }

  .detail-info p {
    margin: 8px 0;
    font-size: 14px;
  }


  .condition-content {
    padding-top: 15px;
  }

  /* 过渡动画优化 */
  .el-collapse-transition {
    transition: 0.3s height ease-in-out, 0.3s padding-top ease-in-out;
  }

  /* 表单元素间距调整 */
  .demo-form-inline {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .el-form-item {
    margin-bottom: 0;
  }
</style>
